import { Component, forwardRef } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import Pagination from "../../../../utils/pagination";
import { downloadReport, loginUrl, priorityNoActionId, toastError, headers, toastSuccess, exhibitionActionId, exhibitorNameActionId, nonEmpanelVendorActionId, gateActionId, hallActionId, truckTrackerActionId, truckTrackerReportId } from "../../../../utils/constants";
import Modal from "react-modal";
import { data } from "jquery";
import { descriptionPreview_action } from "../../../../actions/description_action"
import { fill_action, fill_scoped_action } from "../../../../actions/fillCombo_action"
import Accordion from '@mui/material/Accordion';
import { getExhibitorDetailsReport_action, getReceiptReport_action, getTaxInvoiceReport_action, getExhibitorFinalRankReport_action, getTruckTrackerReport_action } from "../../../../actions/admin_module_action/report_action/report_action";
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExcelJS from 'exceljs';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import Select, { components } from "react-select";

const isIdColumn = (key) => {
    if (!key || typeof key !== 'string') return false;
    const trimmed = key.trim();
    const lower = trimmed.toLowerCase();

    // Standalone ID / Id / id / _id
    if (lower === 'id' || lower === '_id') return true;

    // Preserved business words ending with 'id' that are NOT ID columns
    const safeWords = [
        'paid', 'unpaid', 'liquid', 'solid', 'valid', 'invalid',
        'grid', 'mid', 'acid', 'hybrid', 'pyramid', 'rigid',
        'humid', 'fluid', 'timid', 'vivid', 'rapid', 'candid', 'splendid'
    ];
    if (safeWords.some(w => lower === w || lower.endsWith(' ' + w) || lower.endsWith('_' + w))) {
        return false;
    }

    // Matches any column ending with "id" (e.g. powerfromID, PowerFormID, exregistrationiD, ExhRegistrationID, ExhibitionID, GateID, HallID, etc.)
    if (/id$/i.test(trimmed)) {
        return true;
    }

    // Matches columns starting with id_ or containing _id_
    if (/^id[_\s]/i.test(trimmed) || /[_\s]id[_\s]/i.test(trimmed)) {
        return true;
    }

    return false;
};

const isSerialNoColumn = (key) => {
    if (!key || typeof key !== 'string') return false;
    const clean = key.toLowerCase().replace(/[^a-z]/g, '');
    return clean === 'serialnumber' ||
        clean === 'serialno' ||
        clean === 'srno' ||
        clean === 'srnumber' ||
        clean === 'sno';
};

const ColumnOption = (props) => {
    const { innerRef, innerProps, isFocused, isSelected, label, data } = props;
    return (
        <div
            ref={innerRef}
            {...innerProps}
            style={{
                backgroundColor: isFocused ? '#f1f5f9' : '#ffffff',
                color: '#333333',
                cursor: 'pointer',
                padding: '8px 12px',
                display: 'flex',
                alignItems: 'center',
                userSelect: 'none',
                width: '100%',
                boxSizing: 'border-box',
                transition: 'background-color 0.15s ease',
            }}
        >
            <input
                type="checkbox"
                checked={isSelected}
                onChange={() => { }}
                style={{
                    marginRight: '10px',
                    cursor: 'pointer',
                    width: '16px',
                    height: '16px',
                    accentColor: '#007bff',
                    pointerEvents: 'none',
                }}
            />
            <span
                style={{
                    fontWeight: data && data.value === 'ALL' ? '600' : 'normal',
                    color: '#333333',
                    fontSize: '13px',
                }}
            >
                {label}
            </span>
        </div>
    );
};

class subReport1 extends Component {
    // intialize constructor
    constructor(props) {
        super(props)
        this.state = {
            reportName: '',
            reportID: '',

            isLoading: false,
            showTable: false,
            exhibitionID: '',
            exhibitionList: [],
            exhibitorList: [],
            list: [],
            columnArr: [],
            allColumnArr: [],
            selectedColumns: ['ALL'],
            rowArr: [],
            ExhRegistrationID: '',
            xlrowArr: [],
            reportAccessList: [],
            currentPage: 1,
            recordsPerPage: 10,

            // truck tracker report (ReportID 56) only
            nonEmpanelVendorList: [],
            gateList: [],
            hallList: [],
            statusList: [],
            nonEmpanelVendorID: '',
            fromDate: null,
            toDate: null,
            truckNo: '',
            gateID: '',
            hallID: '',
            statusID: '',
            isTruckTrackerFetching: false
        }

        // truck tracker filters refetch as they change; a free text field needs a
        // pause before firing, and a slow early response must not land on top of a
        // newer one
        this.truckTrackerDebounce = null
        this.truckTrackerRequestId = 0

        this.onViewClick = this.onViewClick.bind(this)
        this.renderTable = this.renderTable.bind(this)
        this.onDownloadClick = this.onDownloadClick.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.getExhibitorDetailsReportlist = this.getExhibitorDetailsReportlist.bind(this)
        this.reportIdCondition = this.reportIdCondition.bind(this)
        this.getReceiptReportlist = this.getReceiptReportlist.bind(this)
        this.getTaxInvoiceReportlist = this.getTaxInvoiceReportlist.bind(this)
        this.getDownloadAccess = this.getDownloadAccess.bind(this)
        this.getViewAccess = this.getViewAccess.bind(this)
        this.isTruckTrackerReport = this.isTruckTrackerReport.bind(this)
        this.renderTruckTrackerFilters = this.renderTruckTrackerFilters.bind(this)
        this.getTruckTrackerReportlist = this.getTruckTrackerReportlist.bind(this)
        this.onTruckTrackerFilterChange = this.onTruckTrackerFilterChange.bind(this)
        this.onClearFilterClick = this.onClearFilterClick.bind(this)
        this.handleColumnChange = this.handleColumnChange.bind(this)
        this.getActiveColumns = this.getActiveColumns.bind(this)
        this.selectAllColumns = this.selectAllColumns.bind(this)
        this.clearAllColumns = this.clearAllColumns.bind(this)
    }

    selectAllColumns(e) {
        if (e && e.preventDefault) e.preventDefault();
        this.setState({ selectedColumns: ['ALL'], currentPage: 1 });
    }

    clearAllColumns(e) {
        if (e && e.preventDefault) e.preventDefault();
        this.setState({ selectedColumns: [], currentPage: 1 });
    }

    handleColumnChange(selected, actionMeta) {
        const { selectedColumns, allColumnArr } = this.state;
        const isAllSelected = selectedColumns.includes('ALL') ||
            (allColumnArr && allColumnArr.length > 0 && selectedColumns.length === allColumnArr.length);

        if (actionMeta) {
            const { action, option, removedValue } = actionMeta;

            if (action === 'clear') {
                this.setState({ selectedColumns: [], currentPage: 1 });
                return;
            }

            if (action === 'select-option') {
                const val = option && option.value;
                if (val === 'ALL') {
                    this.setState({ selectedColumns: ['ALL'], currentPage: 1 });
                } else {
                    const currentCols = isAllSelected ? [...allColumnArr] : [...selectedColumns.filter(c => c !== 'ALL')];
                    if (!currentCols.includes(val)) {
                        currentCols.push(val);
                    }
                    if (currentCols.length >= allColumnArr.length) {
                        this.setState({ selectedColumns: ['ALL'], currentPage: 1 });
                    } else {
                        this.setState({ selectedColumns: currentCols, currentPage: 1 });
                    }
                }
                return;
            }

            if (action === 'deselect-option') {
                const val = option && option.value;
                if (val === 'ALL') {
                    this.setState({ selectedColumns: [], currentPage: 1 });
                } else {
                    if (isAllSelected) {
                        const remaining = allColumnArr.filter(col => col !== val);
                        this.setState({ selectedColumns: remaining, currentPage: 1 });
                    } else {
                        const remaining = selectedColumns.filter(col => col !== val && col !== 'ALL');
                        this.setState({ selectedColumns: remaining, currentPage: 1 });
                    }
                }
                return;
            }

            if (action === 'remove-value') {
                const val = removedValue && removedValue.value;
                if (val === 'ALL' || val === '__SUMMARY__') {
                    this.setState({ selectedColumns: [], currentPage: 1 });
                } else {
                    const remaining = selectedColumns.filter(col => col !== val && col !== 'ALL');
                    this.setState({ selectedColumns: remaining, currentPage: 1 });
                }
                return;
            }
        }

        // Fallback
        const selectedVals = (selected || []).map(item => item.value);
        if (selectedVals.includes('ALL')) {
            this.setState({ selectedColumns: ['ALL'], currentPage: 1 });
        } else {
            this.setState({ selectedColumns: selectedVals.filter(v => v !== '__SUMMARY__'), currentPage: 1 });
        }
    }

    getActiveColumns() {
        const { allColumnArr, selectedColumns } = this.state;
        if (!allColumnArr || allColumnArr.length === 0) return [];
        const filteredAll = allColumnArr.filter(col => !isIdColumn(col));
        if (selectedColumns.includes('ALL')) {
            return filteredAll;
        }
        return filteredAll.filter(col => selectedColumns.includes(col));
    }

    componentDidMount() {
        // this.getExhibitionManualForm()
        const reportID = this.props.location.state != null && this.props.location.state.reportID != null ? this.props.location.state.reportID : ''
        this.getFillList(exhibitionActionId, '', '', '', '', '')
        this.getFillList(exhibitorNameActionId, '', '', '', '', '')
        // truck tracker report has its own set of filters. the non empanel vendor
        // list is not pulled here - it is scoped to the exhibitor company and is
        // only fetched once one is picked
        if (reportID == truckTrackerReportId) {
            this.getFillList(gateActionId, '', '', '', '', '')
            this.getFillList(hallActionId, '', '', '', '', '')
            this.getFillList(truckTrackerActionId, '', '', '', '', '')
        }
        this.setState({
            reportName: this.props.location.state != null && this.props.location.state.reportName != null ? this.props.location.state.reportName : '',
            reportID: reportID,
            reportAccessList: JSON.parse(sessionStorage.getItem('loginDataSS'))['reportAccesslist']
        })
        setTimeout(() => {
            console.log("--->", this.state.reportID)

        }, 100);
    }

    componentWillUnmount() {
        clearTimeout(this.truckTrackerDebounce)
    }

    isTruckTrackerReport() {
        const { reportID } = this.state
        return reportID == truckTrackerReportId
    }

    // 'All' (0) is not a single registration, so it does not unlock the vendor list
    isExhibitorCompanySelected() {
        const { ExhRegistrationID } = this.state
        return ExhRegistrationID != '' && ExhRegistrationID != 'select' && ExhRegistrationID != 0
    }

    // every truck tracker filter refetches as it changes, so the table always
    // matches the filters on screen and View is only ever an explicit refresh.
    //   debounce  - free text fields, so a request fires on a pause not a keystroke
    //   skipFetch - the change is not a complete filter yet (see the date range)
    onTruckTrackerFilterChange(patch, options = {}) {
        const { debounce = false, skipFetch = false } = options
        this.setState(patch, () => {
            if (skipFetch) return
            clearTimeout(this.truckTrackerDebounce)

            // ExhibitionID is the one parameter sp_EntryExitTruckTrack has no
            // default for, so there is nothing to run until it is chosen
            if (!this.isExhibitionSelected()) {
                this.truckTrackerRequestId++ // discard anything already in flight
                this.setState({ list: [], rowArr: [], columnArr: [], xlrowArr: [], allColumnArr: [], selectedColumns: ['ALL'], showTable: false, isTruckTrackerFetching: false })
                return
            }

            if (debounce) {
                this.truckTrackerDebounce = setTimeout(() => this.getTruckTrackerReportlist(), 600)
            } else {
                this.getTruckTrackerReportlist()
            }
        })
    }

    isExhibitionSelected() {
        const { exhibitionID } = this.state
        return exhibitionID != '' && exhibitionID != null && exhibitionID != 'select'
    }

    reportIdCondition(status, value) {
        const { reportID, reportName } = this.state
        // the truck tracker routes both shared dropdowns through
        // onTruckTrackerFilterChange, which refetches the report, so all this adds
        // is re-pulling the fill lists that are scoped to the changed dropdown
        if (this.isTruckTrackerReport()) {
            if (status == 'exhibitionID') {
                const exhID = value == 'select' ? '' : value
                // the vendor list is scoped to exhibition + registration, so it is
                // stale the moment the exhibition changes
                this.onTruckTrackerFilterChange({ exhibitionID: value, nonEmpanelVendorID: '', nonEmpanelVendorList: [] })
                this.getFillList(gateActionId, exhID, '', '', '', '')
                this.getFillList(hallActionId, exhID, '', '', '', '')
                if (this.isExhibitorCompanySelected()) {
                    this.getFillList(nonEmpanelVendorActionId, exhID, '', '', '', this.state.ExhRegistrationID)
                }
            }
            if (status == 'ExhRegistrationID') {
                // vendor list belongs to the chosen exhibitor, so drop the old one
                // on every change before re-fetching against the new registration
                const { exhibitionID } = this.state
                this.onTruckTrackerFilterChange({ ExhRegistrationID: value, nonEmpanelVendorID: '', nonEmpanelVendorList: [] })
                if (value != 'select' && value != 0) {
                    this.getFillList(nonEmpanelVendorActionId, exhibitionID == 'select' ? '' : exhibitionID, '', '', '', value)
                }
            }
            return
        }
        if (reportName == 'Exhibitor Details Report') {
            this.getExhibitorDetailsReportlist(status, value)
        }
        if (reportName == 'Exhibitor Receipt Report') {
            this.getReceiptReportlist(status, value)
        }
        if (reportName == 'Exhibitor Invoice Report') {
            this.getTaxInvoiceReportlist(status, value)
        }
        if (reportName == 'Exhibitor Final Rank') {
            this.getExhibitorFinalRankReportlist(status, value)
        }
    }

    // parseDate(dateStr) {
    //     if (!dateStr) return null;

    //     const [datePart, timePart] = dateStr.split(" ");
    //     const [day, month, year] = datePart.split("-").map(Number);
    //     const [hour = 0, minute = 0, second = 0] = (timePart || "")
    //         .split(":")
    //         .map(Number);

    //     return new Date(year, month - 1, day, hour, minute, second);
    // }

    getExhibitorDetailsReportlist(status, value) {
        const { exhibitionID, ExhRegistrationID } = this.state
        console.log(status, value)
        if (status == 'exhibitionID') {
            this.setState({ exhibitionID: value })
            if (value != 'select') {
                this.setState({ isLoading: true })
                this.props.getExhibitorDetailsReport_action(parseInt(value), ExhRegistrationID == '' || ExhRegistrationID == null ? 0 : ExhRegistrationID)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            // data.data.map((element) =>
                            //     delete element['ADDITIONAL BADGES'])
                            // if (data.data.length > 0) {
                            //     data.data.sort((a, b) => {
                            //         const dateA = this.parseDate(a.SubmittedDate);
                            //         const dateB = this.parseDate(b.SubmittedDate);

                            //         // Put null/blank dates at the end
                            //         if (!dateA && !dateB) return 0;
                            //         if (!dateA) return 1;
                            //         if (!dateB) return -1;

                            //         return dateA - dateB; // Oldest first
                            //     });
                            // }
                            this.setState({ list: data.data })
                            // if (status == 'view') {
                            this.getTableData(data.data)
                            this.setState({ showTable: true })
                            // }
                            // else if (status == 'download') {
                            //     this.onDownloadClick(data.data)
                            //     this.setState({ isLoading: false })
                            this.setState({ isLoading: false })

                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })

            }
            else {
                console.log(value)
                this.setState({ list: [], rowArr: [], columnArr: [], allColumnArr: [], selectedColumns: ['ALL'], showTable: false })
            }
        }
        if (status == 'ExhRegistrationID') {
            console.log(exhibitionID)
            this.setState({ ExhRegistrationID: value })
            if (exhibitionID != null && exhibitionID != '' && exhibitionID != 'select') {
                this.setState({ isLoading: true })
                this.props.getExhibitorDetailsReport_action(exhibitionID, value == 'select' ? 0 : value)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            // data.data.map((element) =>
                            //     delete element['ADDITIONAL BADGES'])
                            // if (data.data.length > 0) {
                            //     data.data.sort((a, b) => {
                            //         const dateA = this.parseDate(a.SubmittedDate);
                            //         const dateB = this.parseDate(b.SubmittedDate);

                            //         // Put null/blank dates at the end
                            //         if (!dateA && !dateB) return 0;
                            //         if (!dateA) return 1;
                            //         if (!dateB) return -1;

                            //         return dateA - dateB; // Oldest first
                            //     });
                            // }
                            this.setState({ list: data.data })
                            // if (status == 'view') {
                            this.getTableData(data.data)
                            this.setState({ showTable: true })
                            // }
                            // else if (status == 'download') {
                            //     this.onDownloadClick(data.data)
                            //     this.setState({ isLoading: false })
                            // }
                            this.setState({ isLoading: false })

                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })
            }
        }
        // if (exhibitionID = null || exhibitionID == '') {
        //     toastError("please select exhibition")
        // }
    }

    getReceiptReportlist(status, value) {
        const { exhibitionID, ExhRegistrationID } = this.state
        console.log(status, value)
        if (status == 'exhibitionID') {
            this.setState({ exhibitionID: value })
            if (value != 'select') {
                this.setState({ isLoading: true })
                this.props.getReceiptReport_action(parseInt(value), ExhRegistrationID == '' || ExhRegistrationID == null ? 0 : ExhRegistrationID)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            // data.data.map((element) =>
                            //     delete element['ADDITIONAL BADGES'])
                            this.setState({ list: data.data })
                            // if (status == 'view') {
                            this.getTableData(data.data)
                            this.setState({ showTable: true })
                            // }
                            // else if (status == 'download') {
                            //     this.onDownloadClick(data.data)
                            //     this.setState({ isLoading: false })
                            this.setState({ isLoading: false })

                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })

            }
            else {
                console.log(value)
                this.setState({ list: [], rowArr: [], columnArr: [], allColumnArr: [], selectedColumns: ['ALL'], showTable: false })
            }
        }
        if (status == 'ExhRegistrationID') {
            console.log(exhibitionID)
            this.setState({ ExhRegistrationID: value })
            if (exhibitionID != null && exhibitionID != '' && exhibitionID != 'select') {
                this.setState({ isLoading: true })
                this.props.getReceiptReport_action(exhibitionID, value == 'select' ? 0 : value)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            // data.data.map((element) =>
                            //     delete element['ADDITIONAL BADGES'])
                            this.setState({ list: data.data })
                            // if (status == 'view') {
                            this.getTableData(data.data)
                            this.setState({ showTable: true })
                            // }
                            // else if (status == 'download') {
                            //     this.onDownloadClick(data.data)
                            //     this.setState({ isLoading: false })
                            // }
                            this.setState({ isLoading: false })

                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })
            }
        }
        // if (exhibitionID = null || exhibitionID == '') {
        //     toastError("please select exhibition")
        // }
    }

    getTaxInvoiceReportlist(status, value) {
        const { exhibitionID, ExhRegistrationID } = this.state
        console.log(status, value)
        if (status == 'exhibitionID') {
            this.setState({ exhibitionID: value })
            if (value != 'select') {
                this.setState({ isLoading: true })
                this.props.getTaxInvoiceReport_action(parseInt(value), ExhRegistrationID == '' || ExhRegistrationID == null ? 0 : ExhRegistrationID)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            // data.data.map((element) =>
                            //     delete element['ADDITIONAL BADGES'])
                            this.setState({ list: data.data })
                            // if (status == 'view') {
                            this.getTableData(data.data)
                            this.setState({ showTable: true })
                            // }
                            // else if (status == 'download') {
                            //     this.onDownloadClick(data.data)
                            //     this.setState({ isLoading: false })
                            this.setState({ isLoading: false })

                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })

            }
            else {
                console.log(value)
                this.setState({ list: [], rowArr: [], columnArr: [], allColumnArr: [], selectedColumns: ['ALL'], showTable: false })
            }
        }
        if (status == 'ExhRegistrationID') {
            console.log(exhibitionID)
            this.setState({ ExhRegistrationID: value })
            if (exhibitionID != null && exhibitionID != '' && exhibitionID != 'select') {
                this.setState({ isLoading: true })
                this.props.getTaxInvoiceReport_action(exhibitionID, value == 'select' ? 0 : value)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            // data.data.map((element) =>
                            //     delete element['ADDITIONAL BADGES'])
                            this.setState({ list: data.data })
                            // if (status == 'view') {
                            this.getTableData(data.data)
                            this.setState({ showTable: true })
                            // }
                            // else if (status == 'download') {
                            //     this.onDownloadClick(data.data)
                            //     this.setState({ isLoading: false })
                            // }
                            this.setState({ isLoading: false })

                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })
            }
        }
        // if (exhibitionID = null || exhibitionID == '') {
        //     toastError("please select exhibition")
        // }
    }

    getExhibitorFinalRankReportlist(status, value) {
        const { exhibitionID, ExhRegistrationID } = this.state
        console.log(status, value)
        if (status == 'exhibitionID') {
            this.setState({ exhibitionID: value })
            if (value != 'select') {
                this.setState({ isLoading: true })
                this.props.getExhibitorFinalRankReport_action(parseInt(value), ExhRegistrationID == '' || ExhRegistrationID == null ? 0 : ExhRegistrationID)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            this.setState({ list: data.data })
                            this.getTableData(data.data)
                            this.setState({ showTable: true })
                            this.setState({ isLoading: false })
                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })
            }
            else {
                console.log(value)
                this.setState({ list: [], rowArr: [], columnArr: [], allColumnArr: [], selectedColumns: ['ALL'], showTable: false })
            }
        }
        if (status == 'ExhRegistrationID') {
            console.log(exhibitionID)
            this.setState({ ExhRegistrationID: value })
            if (exhibitionID != null && exhibitionID != '' && exhibitionID != 'select') {
                this.setState({ isLoading: true })
                this.props.getExhibitorFinalRankReport_action(exhibitionID, value == 'select' ? 0 : value)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            this.setState({ list: data.data })
                            this.getTableData(data.data)
                            this.setState({ showTable: true })
                            this.setState({ isLoading: false })
                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })
            }
        }
    }

    // get Fill List
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        // this is an admin screen, so an exhibitor registration passed here comes
        // from the company dropdown, not from the logged-in user. fill_action lets
        // a stale ExhRegistrationIDSS override it, so scope the call explicitly.
        const fill = from != null && from !== '' ? this.props.fill_scoped_action : this.props.fill_action
        fill(actionID, exhibitionID, moduleID, keyValue, value, from)
            .then((data) => {
                if (data.error != 1) {
                    // Country List
                    if (actionID === exhibitionActionId) {
                        console.log("country data", data.data)
                        this.setState({
                            exhibitionList: data.data,
                            isLoading: false
                        })
                    }
                    // visa  id type
                    if (actionID === exhibitorNameActionId) {
                        console.log("visaIdTypeActionId data", data.data)
                        this.setState({
                            exhibitorList: data.data,
                            isLoading: false
                        })
                    }
                    // non empanel vendor
                    if (actionID === nonEmpanelVendorActionId) {
                        console.log("nonEmpanelVendorActionId data", data.data)
                        this.setState({
                            nonEmpanelVendorList: data.data,
                            isLoading: false
                        })
                    }
                    // gate
                    if (actionID === gateActionId) {
                        console.log("gateActionId data", data.data)
                        this.setState({
                            gateList: data.data,
                            isLoading: false
                        })
                    }
                    // hall
                    if (actionID === hallActionId) {
                        console.log("hallActionId data", data.data)
                        this.setState({
                            hallList: data.data,
                            isLoading: false
                        })
                    }
                    // truck tracker status
                    if (actionID === truckTrackerActionId) {
                        console.log("truckTrackerActionId data", data.data)
                        this.setState({
                            statusList: data.data,
                            isLoading: false
                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    // Runs the report. Called on every filter change, and again on View.
    //
    // showOverlay is off by default on purpose: the shared Loader is a fixed, full
    // screen element that sits above the filter row and eats pointer events, so
    // using it for the automatic refetches would swallow the user's next keystroke
    // or dropdown click. Only the explicit View click blocks the page.
    getTruckTrackerReportlist(options = {}) {
        const { showOverlay = false } = options
        const { exhibitionID, ExhRegistrationID, nonEmpanelVendorID, fromDate, toDate, truckNo, gateID, hallID, statusID } = this.state

        const requestId = ++this.truckTrackerRequestId
        this.setState({ isTruckTrackerFetching: true, isLoading: showOverlay ? true : this.state.isLoading })

        this.props.getTruckTrackerReport_action(exhibitionID, ExhRegistrationID, nonEmpanelVendorID, fromDate, toDate, truckNo, gateID, hallID, statusID)
            .then((data) => {
                // filters can change faster than this SP responds, so an older
                // request must not overwrite the results of a newer one
                if (requestId !== this.truckTrackerRequestId) return
                const settled = { isLoading: false, isTruckTrackerFetching: false }

                // axiosGet swallows transport errors and resolves with null
                if (data == null) {
                    this.setState(settled)
                    toastError('Something went wrong!.....')
                    return
                }
                if (data.error != 1) {
                    // getTableData derives the columns from the first row, so an
                    // empty result correctly leaves the table showing 'Record not found'
                    this.setState({ list: data.data })
                    this.getTableData(data.data)
                    this.setState({ ...settled, showTable: true })
                }
                else {
                    this.setState({ ...settled, list: [], rowArr: [], columnArr: [], xlrowArr: [], allColumnArr: [], selectedColumns: ['ALL'], showTable: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                if (requestId !== this.truckTrackerRequestId) return
                this.setState({ isLoading: false, isTruckTrackerFetching: false })
            })
    }

    // clears every filter except the exhibition - it is the one required field, so
    // keeping it means Clear leaves the row immediately usable rather than back at
    // square one. The Gate and Hall lists are left alone for the same reason: they
    // are scoped to the retained exhibition and are still correct. The vendor list
    // is emptied along with its selection because it is fetched per exhibitor, and
    // no exhibitor is selected after a clear.
    onClearFilterClick() {
        // goes through the normal change path so the report reloads unfiltered for
        // the retained exhibition, rather than leaving the user staring at a blank
        // table until they touch something
        this.onTruckTrackerFilterChange({
            ExhRegistrationID: '',
            nonEmpanelVendorID: '',
            nonEmpanelVendorList: [],
            fromDate: null,
            toDate: null,
            truckNo: '',
            gateID: '',
            hallID: '',
            statusID: ''
        })
    }

    onViewClick() {
        const { exhibitionID, ExhRegistrationID } = this.state
        console.log(this.state.list)
        if (exhibitionID == '' || exhibitionID == null || exhibitionID == 'select') {
            toastError('Please select exhibition')
        }
        else if (this.isTruckTrackerReport()) {
            // filters already refetch on change, so View is an explicit refresh -
            // and being deliberate, it is allowed to block the page
            clearTimeout(this.truckTrackerDebounce)
            this.getTruckTrackerReportlist({ showOverlay: true })
        }
        else {
            this.setState({ showTable: true })
        }
    }

    getTableData(list) {
        // for column data 
        var columnArray = []
        var rowData = []
        console.log('columnArray', list);

        list.map((data, index) => {
            if (index == 0) {
                console.log('columnArray', data, Object.keys);

                Object.keys(data).map((key, index) => {
                    if (!isIdColumn(key)) {
                        columnArray.push(key)
                    }
                })
            }
        })

        const isSameColumns = this.state.allColumnArr && this.state.allColumnArr.length === columnArray.length &&
            columnArray.every((col, idx) => col === this.state.allColumnArr[idx]);

        this.setState({
            columnArr: columnArray,
            allColumnArr: columnArray,
            selectedColumns: isSameColumns ? this.state.selectedColumns : ['ALL'],
            currentPage: 1,
        })
        console.log('columnArray', columnArray);
        var xlRowdata = []
        // for row data
        list.map((data, index) => {
            const updatedRow = { ...data }
            Object.keys(updatedRow).forEach((k) => {
                if (isSerialNoColumn(k)) {
                    updatedRow[k] = index + 1
                }
            })
            rowData.push(Object.values(updatedRow))
            xlRowdata.push(updatedRow)
        })
        this.setState({ rowArr: rowData, xlrowArr: xlRowdata, currentPage: 1 })
        setTimeout(() => {
            console.log(rowData, xlRowdata)
        }, 500);

        // this.renderTable()
        // if (listName == 'SLA_BreachList') {
        //     console.log("onReset 12", list)

        //     this.setState({
        //         SLA_BreachRowData: rowData,
        //         SLA_BreachColumnArray: columnArray,
        //         temp_SLA_BreachRowData: rowData,
        //     })
        //     columnArray = []
        //     rowData = []
        //     console.log("onReset 12 original_SLA_BreachRowData", original_SLA_BreachRowData)
        //     setTimeout(() => {
        //         this.getClientList()
        //     }, 300);
        // }
        // if (listName == 'original_SLA_BreachList') {
        //     console.log("onReset 12 original_SLA_BreachList", list)
        //     this.setState({
        //         original_SLA_BreachRowData: rowData,
        //         SLA_BreachRowData: rowData
        //     })
        //     columnArray = []
        //     rowData = []
        //     console.log("onReset 12 original_SLA_BreachRowData", original_SLA_BreachRowData)

        // }
    }

    onDownloadClick() {
        const { exhibitionID } = this.state
        if (exhibitionID == '' || exhibitionID == null || exhibitionID == 0) {
            toastError('Please select exhibition')
        }
        else {
            this.setState({ showTable: true })
            this.downloadExcel()
        }
    }

    getViewAccess() {
        const { reportAccessList, reportID } = this.state
        const moduleAccess = reportAccessList.find((item) => item.ReportID == reportID);
        if (moduleAccess) {
            return moduleAccess.ViewAccess;
        } else {
            return false
        }
        return false;
    }

    getDownloadAccess() {
        const { reportAccessList, reportID } = this.state
        const moduleAccess = reportAccessList.find((item) => item.ReportID == reportID);
        if (moduleAccess) {
            return moduleAccess.DownloadAccess;
        } else {
            return false
        }
        return false;
    }

    getFormattedDateTime() {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        const hours = String(now.getHours()).padStart(2, '0');
        return `${day}${month}${year} ${hours}pm`;
    }

    async downloadExcel() {
        const { xlrowArr, columnArr, reportName, list, selectedColumns } = this.state;
        const activeColumns = this.getActiveColumns();

        if (activeColumns.length === 0) {
            toastError('Please select at least one column to export');
            return;
        }

        try {
            const workbook = new ExcelJS.Workbook();
            const isExhibitorFinalRank = reportName === 'Exhibitor Final Rank';
            const isAllSelected = selectedColumns.includes('ALL');

            const sheetName = (isExhibitorFinalRank && isAllSelected) ? `Final Rank till ${this.getFormattedDateTime()}` : 'Sheet A';
            const sheet1 = workbook.addWorksheet(sheetName);

            const columnWidths1 = [15.6640625, 22.6640625, 71.6640625, 26.5546875, 15.77734375, 35.5546875, 36.21875, 36.44140625, 51.21875];

            // For Exhibitor Final Rank when ALL columns are selected, use exact column names from reference file
            if (isExhibitorFinalRank && isAllSelected) {
                const sheet1Headers = [
                    'ExhRegistrationID',
                    'Application Reference No.',
                    'Company Name',
                    'Chapter Name',
                    'Application Status',
                    '1st Rank\n(Basis of 1st installment Full Paid Receipt)',
                    '2nd Rank\n(Basis of 2nd installment Full Paid Receipt)',
                    'Final Rank\n(1st Installment weightage =60 & 2nd Installment weightage =40)\n((1st rank * 60/100)+ (2nd Rank * 40/100))',
                    'Serialised Priority Number(Display in exhibitor\'s dashboard)',
                    'Person Name',
                    'Primary Email',
                    'Secondary Email',
                    'Email',
                    'Mobile No',
                    'Alternate Mobile No',
                    'Area',
                    'Dimensions',
                    'Open Sides',
                    'Double Storey Area',
                    'Stall Category',
                    'Payment Status',
                ];

                sheet1.columns = sheet1Headers.map((col, index) => ({
                    header: col,
                    key: col,
                    width: columnWidths1[index] || 18
                }));

                const headerRow = sheet1.getRow(1);
                headerRow.height = 57.6;

                sheet1Headers.forEach((col, index) => {
                    const cell = headerRow.getCell(index + 1);
                    if (index < 5) {
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB8CCE4' } };
                    } else {
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFC000' } };
                    }
                    cell.font = { size: 11, color: { argb: 'FF000000' } };
                    cell.alignment = { horizontal: 'center', vertical: 'center', wrapText: true };
                    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                });

                xlrowArr.forEach((row, rowIndex) => {
                    const excelRow = sheet1.addRow(row);

                    // Map data to columns by index
                    sheet1Headers.forEach((header, colIndex) => {
                        const cell = excelRow.getCell(colIndex + 1);

                        // Try to find matching value in row
                        let value = '';
                        // First try exact match
                        if (row[header] !== undefined) {
                            value = row[header];
                        } else {
                            // Try to find by similar keys
                            const keys = Object.keys(row);
                            let matchingKey = null;

                            // Special handling for specific columns
                            if (header.includes('Serialised Priority Number')) {
                                matchingKey = keys.find(k =>
                                    k.toLowerCase().includes('serialised') ||
                                    k.toLowerCase().includes('priority') ||
                                    k === 'ITME2026/1' || // Example value pattern
                                    k.includes('ITME')
                                );
                            } else if (header.includes('1st Rank') && header.includes('Basis')) {
                                matchingKey = keys.find(k =>
                                    (k.includes('1st Rank') && k.includes('Basis')) ||
                                    k === '1st Rank' ||
                                    k.includes('installment')
                                );
                            } else if (header.includes('2nd Rank') && header.includes('Basis')) {
                                matchingKey = keys.find(k =>
                                    (k.includes('2nd Rank') && k.includes('Basis')) ||
                                    k === '2nd Rank'
                                );
                            } else if (header.includes('Final Rank') && header.includes('weightage')) {
                                matchingKey = keys.find(k =>
                                    (k.includes('Final Rank') && k.includes('weightage')) ||
                                    k === 'Final Rank'
                                );
                            } else {
                                // Generic matching for other columns
                                const headerBase = header.split('\n')[0].toLowerCase();
                                matchingKey = keys.find(k =>
                                    k.toLowerCase().includes(headerBase) ||
                                    headerBase.includes(k.toLowerCase())
                                );
                            }

                            if (matchingKey) {
                                value = row[matchingKey];
                            }
                        }

                        cell.value = value || '';
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
                        cell.font = { size: 11, color: { argb: 'FF000000' } };
                        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                    });
                });
            } else {
                sheet1.columns = activeColumns.map((col, index) => ({
                    header: col,
                    key: col,
                    width: columnWidths1[index] || 18
                }));

                const headerRow = sheet1.getRow(1);
                headerRow.font = { bold: true, size: 11 };
                headerRow.alignment = { horizontal: 'center', vertical: 'center', wrapText: true };
                headerRow.eachCell(cell => {
                    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                });

                xlrowArr.forEach((row, rowIndex) => {
                    const rowData = {};
                    activeColumns.forEach(col => {
                        rowData[col] = row[col] !== undefined && row[col] !== null ? row[col] : '';
                    });
                    sheet1.addRow(rowData);
                });
            }

            if (isExhibitorFinalRank && isAllSelected) {
                const sheet2 = workbook.addWorksheet('Chapter wise ranking');
                const columnWidths2 = [15.6640625, 22.6640625, 56.33203125, 26.88671875, 15.6640625, 37.77734375, 32.77734375, 45.6640625, 49.6640625];

                const sheet2Headers = ['Sr No.', 'Application Reference No.', 'Company Name', 'Chapter Name', 'Application Status', '1st Rank\n(Basis of 1st installment Full Paid Receipt)', '2nd Rank\n(Basis of 2nd installment Full Paid Receipt)', 'Final Rank\n(1st Installment weightage =60 & 2nd Installment weightage =40)\n((1st rank * 60/100)+ (2nd Rank * 40/100))', 'Serialised Priority Number(Display in exhibitor\'s dashboard)', 'Person Name',
                    'Primary Email', 'Secondary Email', 'Email', 'Mobile No', 'Alternate Mobile No', 'Area', 'Dimensions', 'Open Sides', 'Double Storey Area', 'Stall Category', 'Payment Status'];

                sheet2.columns = sheet2Headers.map((col, index) => ({
                    header: col,
                    key: col,
                    width: columnWidths2[index] || 18
                }));

                const headerRow = sheet2.getRow(1);
                headerRow.height = 57.6;

                sheet2Headers.forEach((col, index) => {
                    const cell = headerRow.getCell(index + 1);
                    if (index < 5) {
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB8CCE4' } };
                    } else {
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFC000' } };
                    }
                    cell.font = { size: 11, color: { argb: 'FF000000' } };
                    cell.alignment = { horizontal: 'center', vertical: 'center', wrapText: true };
                    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                });

                const groupedData = this.groupDataByChapter(xlrowArr);
                let dataRowIndex = 2;

                groupedData.forEach((row) => {
                    const isChapterHeader = row.isChapterHeader === true;
                    const isEmptyRow = row.isEmptyRow === true;

                    dataRowIndex++;

                    if (isEmptyRow) {
                        // Skip empty rows (they'll just be blank)
                        return;
                    }

                    if (isChapterHeader) {
                        const chapterRow = sheet2.getRow(dataRowIndex);
                        chapterRow.height = 35; // Increased height for chapter header

                        sheet2Headers.forEach((col, index) => {
                            const cell = chapterRow.getCell(index + 1);

                            if (index === 3) {
                                // Column D: Set chapter name value
                                cell.value = row[col] || row['Chapter Name'] || '';
                                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9E1F2' } };
                                cell.font = { bold: true, size: 18, color: { argb: 'FF000000' } };
                                cell.alignment = { horizontal: 'center', vertical: 'center' };
                                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                            } else if (index === 4 || index === 5) {
                                // Columns E, F: Empty value but styled (for merge)
                                cell.value = '';
                                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9E1F2' } };
                                cell.font = { bold: true, size: 18, color: { argb: 'FF000000' } };
                                cell.alignment = { horizontal: 'center', vertical: 'center' };
                                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                            } else {
                                // Columns A, B, C: White/empty
                                cell.value = '';
                                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
                                cell.font = { size: 11, color: { argb: 'FF000000' } };
                                cell.alignment = { horizontal: 'left', vertical: 'center' };
                                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                            }
                        });

                        // Merge cells D:F for chapter header
                        sheet2.mergeCells(`D${dataRowIndex}:F${dataRowIndex}`);
                    } else {
                        const dataRow = sheet2.getRow(dataRowIndex);

                        sheet2Headers.forEach((col, index) => {
                            const cell = dataRow.getCell(index + 1);

                            // Try to find matching value in row
                            let value = '';
                            const keys = Object.keys(row);

                            // First try exact match
                            if (row[col] !== undefined && row[col] !== '') {
                                value = row[col];
                            } else {
                                // Try alternative key matching strategies
                                let matchingKey = null;

                                if (col === 'Sr No.') {
                                    matchingKey = keys.find(k => k === 'Sr No.' || k === 'Sr No' || k === 'srNo');
                                } else if (col === 'Application Reference No.') {
                                    matchingKey = keys.find(k => k === 'Application Reference No.' || k === 'Application Reference No');
                                } else if (col === 'Company Name') {
                                    matchingKey = keys.find(k => k === 'Company Name' || k === 'CompanyName');
                                } else if (col === 'Chapter Name') {
                                    matchingKey = keys.find(k => k === 'Chapter Name' || k === 'ChapterName');
                                } else if (col === 'Application Status') {
                                    matchingKey = keys.find(k => k === 'Application Status' || k === 'ApplicationStatus');
                                } else if (col.includes('Final Rank') && col.includes('weightage')) {
                                    // Check Final Rank first (before 2nd Rank) since Final Rank header contains "2nd Rank" text
                                    matchingKey = keys.find(k => k === 'Final Rank' || (k.includes('Final') && k.includes('Rank')));
                                } else if (col.includes('1st Rank')) {
                                    matchingKey = keys.find(k => k === '1st Rank' || (k.includes('1st') && k.includes('Rank') && !k.includes('2nd') && !k.includes('Final')));
                                } else if (col.includes('2nd Rank') && !col.includes('Final')) {
                                    matchingKey = keys.find(k => k === '2nd Rank' || (k.includes('2nd') && k.includes('Rank') && !k.includes('Final')));
                                } else if (col.includes('Serialised Priority Number')) {
                                    matchingKey = keys.find(k =>
                                        k === 'Serialised Priority Number' ||
                                        k === 'Serialised Priority Number(Display in exhibitor\'s dashboard)' ||
                                        k.toLowerCase().includes('serialised') ||
                                        k.toLowerCase().includes('priority')
                                    );
                                } else if (col === 'Person Name') {
                                    matchingKey = keys.find(k => k === 'Person Name' || k === 'PersonName');
                                } else if (col === 'Primary Email') {
                                    matchingKey = keys.find(k => k === 'Primary Email' || k === 'PrimaryEmail');
                                } else if (col === 'Secondary Email') {
                                    matchingKey = keys.find(k => k === 'Secondary Email' || k === 'SecondaryEmail');
                                } else if (col === 'Email') {
                                    matchingKey = keys.find(k => k === 'Email' || k === 'Email');
                                } else if (col === 'Mobile No') {
                                    matchingKey = keys.find(k => k === 'Mobile No' || k === 'MobileNo');
                                } else if (col === 'Alternate Mobile No') {
                                    matchingKey = keys.find(k => k === 'Alternate Mobile No' || k === 'AlternateMobileNo');
                                } else if (col === 'Area') {
                                    matchingKey = keys.find(k => k === 'Area' || k === 'Area');
                                } else if (col === 'Dimensions') {
                                    matchingKey = keys.find(k => k === 'Dimensions' || k === 'Dimensions');
                                } else if (col === 'Open Sides') {
                                    matchingKey = keys.find(k => k === 'Open Sides' || k === 'OpenSides');
                                } else if (col === 'Double Storey Area') {
                                    matchingKey = keys.find(k => k === 'Double Storey Area' || k === 'DoubleStoreyArea');
                                } else if (col === 'Stall Category') {
                                    matchingKey = keys.find(k => k === 'Stall Category' || k === 'StallCategory');
                                } else if (col === 'Payment Status') {
                                    matchingKey = keys.find(k => k === 'Payment Status' || k === 'PaymentStatus');
                                }
                                if (matchingKey) {
                                    value = row[matchingKey];
                                }
                            }

                            cell.value = value || '';
                            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
                            cell.font = { size: 11, color: { argb: 'FF000000' } };
                            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                        });
                    }
                });
            }

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${reportName}.xlsx`;
            link.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error generating Excel:', error);
            toastError('Error downloading report');
        }
    }

    groupDataByChapter(data) {
        const grouped = {};
        const chapterOrder = [];

        data.forEach((item) => {
            const chapter = item['Chapter Name'] || 'Others';
            if (!grouped[chapter]) {
                grouped[chapter] = [];
                chapterOrder.push(chapter);
            }
            grouped[chapter].push(item);
        });

        const groupedData = [];
        let isFirstChapter = true;

        chapterOrder.forEach((chapter) => {
            // Add empty row before chapter header (except before first chapter)
            if (!isFirstChapter) {
                groupedData.push({ isEmptyRow: true });
            }
            isFirstChapter = false;

            // Create chapter header row with chapter name only in column D (will be merged D:F)
            const chapterHeader = {
                'Sr No.': '',
                'Application Reference No.': '',
                'Company Name': '',
                'Chapter Name': chapter,
                'Application Status': '',
                '1st Rank\n(Basis of 1st installment Full Paid Receipt)': '',
                '2nd Rank\n(Basis of 2nd installment Full Paid Receipt)': '',
                'Final Rank\n(1st Installment weightage =60 & 2nd Installment weightage =40)\n((1st rank * 60/100)+ (2nd Rank * 40/100))': '',
                'Serialised Priority Number(Display in exhibitor\'s dashboard)': '',
                'Person Name': '',
                'Primary Email': '',
                'Secondary Email': '',
                'Email': '',
                'Mobile No': '',
                'Alternate Mobile No': '',
                'Area': '',
                'Dimensions': '',
                'Open Sides': '',
                'Double Storey Area': '',
                'Stall Category': '',
                'Payment Status': '',

                isChapterHeader: true
            };
            groupedData.push(chapterHeader);

            // Add empty row after chapter header
            groupedData.push({ isEmptyRow: true });

            // Reset serial number for each chapter
            let chapterSrNo = 1;

            // Add data rows with Sr No. (reset for each chapter)
            grouped[chapter].forEach((item) => {
                // Copy all original item properties to preserve data
                const newRow = { ...item, 'Sr No.': chapterSrNo };
                groupedData.push(newRow);
                chapterSrNo++;
            });
        });

        return groupedData;
    }


    // extra filters shown only for the truck tracker report (ReportID 56)
    renderTruckTrackerFilters() {
        const { nonEmpanelVendorList, gateList, hallList, statusList,
            nonEmpanelVendorID, fromDate, toDate, truckNo, gateID, hallID, statusID } = this.state
        return (
            <>
                <div className="col-xl-3">
                    <label className="text-dark mb-1" style={{ fontSize: '14px', height: '22px', lineHeight: '22px' }}>Non Empanel Vendor</label>
                    <select className="form-control"
                        value={nonEmpanelVendorID}
                        disabled={!this.isExhibitorCompanySelected()}
                        onChange={(e) => this.onTruckTrackerFilterChange({ nonEmpanelVendorID: e.target.value })}  >
                        <option value={'select'}>{this.isExhibitorCompanySelected() ? 'Select' : 'Select exhibitor company first'}</option>
                        {
                            nonEmpanelVendorList.length > 0 && nonEmpanelVendorList.map(data => (
                                <option value={data.ContractorID} key={data.ContractorID}>{data.CompanyName}</option>
                            ))
                        }
                    </select>
                </div>
                <div className="col-xl-3">
                    <label className="text-dark mb-1" style={{ fontSize: '14px', height: '22px', lineHeight: '22px' }}>Venue From Date - To Date</label>
                    <DatePicker
                        selectsRange
                        startDate={fromDate}
                        endDate={toDate}
                        dateFormat={"dd/MM/yyyy"}
                        className="form-control"
                        // the range picker fires once with only the start date chosen;
                        // refetching there would run a half specified range
                        onChange={(dates) => this.onTruckTrackerFilterChange(
                            { fromDate: dates[0], toDate: dates[1] },
                            { skipFetch: dates[0] != null && dates[1] == null }
                        )}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        isClearable
                        portalId="datepicker-portal"
                        placeholderText="From Date - To Date"
                    />
                </div>
                <div className="col-xl-3">
                    <label className="text-dark mb-1" style={{ fontSize: '14px', height: '22px', lineHeight: '22px' }}>Truck No</label>
                    <input
                        type="text"
                        className="form-control"
                        value={truckNo}
                        placeholder="Truck No"
                        onChange={(e) => this.onTruckTrackerFilterChange({ truckNo: e.target.value }, { debounce: true })}
                    />
                </div>
                <div className="col-xl-3">
                    <label className="text-dark mb-1" style={{ fontSize: '14px', height: '22px', lineHeight: '22px' }}>Gate</label>
                    <select className="form-control"
                        value={gateID}
                        onChange={(e) => this.onTruckTrackerFilterChange({ gateID: e.target.value })}  >
                        <option value={'select'}>Select</option>
                        {
                            gateList.length > 0 && gateList.map(data => (
                                <option value={data.GateID} key={data.GateID}>{data.GateName}</option>
                            ))
                        }
                    </select>
                </div>
                <div className="col-xl-3">
                    <label className="text-dark mb-1" style={{ fontSize: '14px', height: '22px', lineHeight: '22px' }}>Hall</label>
                    <select className="form-control"
                        value={hallID}
                        onChange={(e) => this.onTruckTrackerFilterChange({ hallID: e.target.value })}  >
                        <option value={'select'}>Select</option>
                        {
                            hallList.length > 0 && hallList.map(data => (
                                <option value={data.HallId} key={data.HallId}>{data.HallName}</option>
                            ))
                        }
                    </select>
                </div>
                <div className="col-xl-3">
                    <label className="text-dark mb-1" style={{ fontSize: '14px', height: '22px', lineHeight: '22px' }}>Status</label>
                    <select className="form-control"
                        value={statusID}
                        onChange={(e) => this.onTruckTrackerFilterChange({ statusID: e.target.value })}  >
                        <option value={'select'}>Select</option>
                        {
                            statusList.length > 0 && statusList.map(data => (
                                <option value={data.ID} key={data.ID}>{data.Name}</option>
                            ))
                        }
                    </select>
                </div>
            </>
        )
    }

    renderTable() {
        const { xlrowArr, currentPage, recordsPerPage } = this.state
        const activeColumns = this.getActiveColumns()
        const totalRecords = (xlrowArr && xlrowArr.length) || 0
        const nPages = Math.ceil(totalRecords / recordsPerPage) || 1
        const indexOfLastRecord = currentPage * recordsPerPage
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = (xlrowArr && xlrowArr.slice(indexOfFirstRecord, indexOfLastRecord)) || []

        return (
            <div className="mt-3">
                <div className="table-responsive px-1 sticky-table-wrapper service-list-grid mx-2">
                    <table className="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                        <thead className="table-light">
                            <tr>
                                {activeColumns.length > 0 && activeColumns.map((data, index) => (
                                    <th key={index} style={{ backgroundColor: '#f8f9fa', fontWeight: '600' }}>{data}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {activeColumns.length === 0 ? (
                                <tr>
                                    <td colSpan={3} style={{ textAlign: 'center', padding: '24px', color: '#6c757d' }}>
                                        Please select at least one column from the dropdown above to display data.
                                    </td>
                                </tr>
                            ) : totalRecords > 0 ? (
                                currentRecords.map((data, i) => (
                                    <tr key={indexOfFirstRecord + i}>
                                        {activeColumns.map((element, index) => (
                                            <td key={index}>
                                                {isSerialNoColumn(element)
                                                    ? (indexOfFirstRecord + i + 1)
                                                    : (data[element] !== undefined && data[element] !== null ? String(data[element]) : '')}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={activeColumns.length || 3} style={{ textAlign: 'center', padding: '24px', color: '#6c757d' }}>
                                        Record not found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="mt-2 float-left trp">
                    {totalRecords > 0 ? (
                        <Pagination
                            nPages={nPages}
                            currentPage={currentPage}
                            setCurrentPage={(page) => this.setState({ currentPage: page })}
                        />
                    ) : <></>}
                    <div className="table-record-pages">
                        <p className="mb-0">{`${currentPage} of ${nPages} pages`}</p>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { isLoading, reportID, reportName, rowArr, exhibitorList, showTable, exhibitionID, ExhRegistrationID, exhibitionList, xlrowArr, columnArr, allColumnArr, selectedColumns, list, isTruckTrackerFetching } = this.state

        const isAllSelected = selectedColumns.includes('ALL') ||
            (allColumnArr && allColumnArr.length > 0 && selectedColumns.length === allColumnArr.length);

        const columnOptions = (allColumnArr && allColumnArr.length > 0)
            ? [{ value: 'ALL', label: 'All Columns' }, ...allColumnArr.map(col => ({ value: col, label: col }))]
            : []

        let selectedColumnOptions = []
        if (isAllSelected) {
            selectedColumnOptions = [{ value: 'ALL', label: `All Columns Selected (${allColumnArr.length})` }]
        } else if (selectedColumns.length === 0) {
            selectedColumnOptions = []
        } else if (selectedColumns.length <= 2) {
            selectedColumnOptions = selectedColumns.map(col => ({ value: col, label: col }))
        } else {
            selectedColumnOptions = [{ value: '__SUMMARY__', label: `${selectedColumns.length} of ${allColumnArr.length} Columns Selected` }]
        }
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <div className={JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ? "with-dr-container" : "with-dr-container com-height"} style={{ marginTop: '5rem', color: 'white' }}>
                    <AdminDrawer />
                    <div className="row">
                        <div className="step-name-space" style={{ zIndex: 9 }}>
                            <p>{reportName}</p>
                        </div>
                    </div>

                    <div className="main-container" >
                        <div className="row mt-5 m-2">
                            <div className="col-xl-3">
                                <label className="text-dark mb-1" style={{ fontSize: '14px', height: '22px', lineHeight: '22px' }}>
                                    Select Exhibition <span className="text-red">*</span>
                                </label>
                                <select className="form-control"
                                    value={exhibitionID}
                                    // disabled={isView}
                                    onChange={(e) => this.reportIdCondition("exhibitionID", e.target.value != '' && e.target.value)}  >
                                    <option value={'select'}>Select</option>
                                    {
                                        exhibitionList.length > 0 && exhibitionList.map(data => (
                                            <option value={data.ExhibitionID} key={data.ExhibitionID}>{data.ExhibitionName}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="col-xl-3">
                                <label className="text-dark mb-1" style={{ fontSize: '14px', height: '22px', lineHeight: '22px' }}>
                                    Select Exhibitor company
                                </label>
                                <select className="form-control"
                                    value={ExhRegistrationID}
                                    // disabled={isView}
                                    onChange={(e) => this.reportIdCondition('ExhRegistrationID', e.target.value != '' && e.target.value)}  >
                                    <option value={'select'}>Select</option>
                                    <option value={0}>All</option>

                                    {
                                        exhibitorList.length > 0 && exhibitorList.map(data => (
                                            <option value={data.ExhRegistrationID} key={data.ExhRegistrationID}>{data.CompanyName}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            {allColumnArr && allColumnArr.length > 0 && (
                                <div className="col-xl-6">
                                    <div className="d-flex justify-content-between align-items-center mb-1" style={{ height: '22px', lineHeight: '22px' }}>
                                        <label className="text-dark mb-0 text-nowrap" style={{ fontSize: '14px', lineHeight: '22px' }}>
                                            Select Column
                                        </label>
                                        <div className="text-nowrap" style={{ fontSize: '12px', lineHeight: '22px' }}>
                                            <span
                                                onClick={this.selectAllColumns}
                                                role="button"
                                                style={{ color: '#007bff', cursor: 'pointer', fontWeight: '500' }}
                                                title="Select all columns"
                                            >
                                                Select All
                                            </span>
                                            <span className="text-muted mx-1">|</span>
                                            <span
                                                onClick={this.clearAllColumns}
                                                role="button"
                                                style={{ color: '#dc3545', cursor: 'pointer', fontWeight: '500' }}
                                                title="Clear all columns"
                                            >
                                                Clear All
                                            </span>
                                        </div>
                                    </div>
                                    <Select
                                        isMulti
                                        className="text-left"
                                        classNamePrefix="col-select"
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                        menuPosition="fixed"
                                        placeholder="Select Column(s)"
                                        options={columnOptions}
                                        value={selectedColumnOptions}
                                        onChange={this.handleColumnChange}
                                        components={{ Option: ColumnOption }}
                                        isOptionSelected={(option) => {
                                            if (option.value === 'ALL') return isAllSelected;
                                            if (isAllSelected) return true;
                                            return selectedColumns.includes(option.value);
                                        }}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: '38px',
                                                height: '38px',
                                                color: '#333',
                                                borderColor: '#ced4da',
                                                boxShadow: 'none',
                                            }),
                                            valueContainer: (base) => ({
                                                ...base,
                                                height: '36px',
                                                padding: '0 8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexWrap: 'nowrap',
                                                overflow: 'hidden',
                                            }),
                                            indicatorsContainer: (base) => ({
                                                ...base,
                                                height: '36px',
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 999999,
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 999999,
                                                color: '#333',
                                                boxShadow: '0 6px 16px rgba(0,0,0,0.18)',
                                                borderRadius: '4px',
                                                border: '1px solid #e2e8f0',
                                                backgroundColor: '#ffffff',
                                            }),
                                            menuList: (base) => ({
                                                ...base,
                                                maxHeight: '280px',
                                                padding: '4px 0',
                                            }),
                                            option: () => ({
                                                padding: 0,
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: '#f1f5f9',
                                                borderRadius: '4px',
                                                margin: '0',
                                                border: '1px solid #e2e8f0',
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                color: '#333333',
                                                fontWeight: '500',
                                                fontSize: '13px',
                                                padding: '2px 6px',
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                color: '#666666',
                                                cursor: 'pointer',
                                                ':hover': {
                                                    backgroundColor: '#e2e8f0',
                                                    color: '#d32f2f',
                                                },
                                            }),
                                        }}
                                    />
                                </div>
                            )}

                            {this.isTruckTrackerReport() && this.renderTruckTrackerFilters()}

                            <div className="col-12 mt-3 d-flex align-items-center flex-wrap" style={{ gap: '15px' }}>
                                <button
                                    type="button"
                                    className="btn btn-aqua"
                                    style={{ width: 140, fontSize: 15, padding: '7px 12px', borderRadius: '4px' }}
                                    // disabled={!this.getViewAccess()}
                                    onClick={this.onViewClick}
                                >
                                    View
                                </button>
                                {list.length > 0 ? (
                                    <button
                                        className="btn btn-aqua"
                                        // disabled={!this.getDownloadAccess()}
                                        style={{ width: 140, fontSize: 15, padding: '7px 12px', borderRadius: '4px' }}
                                        onClick={() => this.downloadExcel()}
                                    >
                                        Download
                                    </button>
                                ) : (
                                    <button
                                        className="btn btn-aqua"
                                        style={{ width: 140, fontSize: 15, padding: '7px 12px', borderRadius: '4px', opacity: 0.65 }}
                                        disabled={true}
                                    >
                                        Download
                                    </button>
                                )}
                                {this.isTruckTrackerReport() && (
                                    <button
                                        type="button"
                                        className="btn btn-gray"
                                        style={{ width: 140, fontSize: 15, padding: '7px 12px', borderRadius: '4px' }}
                                        onClick={this.onClearFilterClick}
                                    >
                                        Clear Filter
                                    </button>
                                )}
                                <button
                                    type="button"
                                    className="btn btn-gray"
                                    style={{ width: 140, fontSize: 15, padding: '7px 12px', borderRadius: '4px' }}
                                    onClick={() => window.history.back()}
                                >
                                    Back
                                </button>
                            </div>
                        </div>
                        {/* the refetches deliberately skip the blocking Loader, so say
                            so inline instead - otherwise a slow filter change looks
                            like nothing happened */}
                        {isTruckTrackerFetching && !isLoading &&
                            <div className="text-dark m-2">Loading...</div>
                        }
                        {showTable && this.renderTable()}
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, fill_scoped_action, getExhibitorDetailsReport_action, getReceiptReport_action, getTaxInvoiceReport_action, getExhibitorFinalRankReport_action, getTruckTrackerReport_action })(subReport1))